import { render, staticRenderFns } from "./terminados.vue?vue&type=template&id=02f3adf0&"
import script from "./terminados.vue?vue&type=script&lang=js&"
export * from "./terminados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports